/**
 * Audit log actions.
 * @module actions/auditLog/auditLog
 */

import {
  GET_AUDIT_LOG,
  GET_AUDIT_LOG_CSV,
  RESET_AUDIT_LOG,
} from '../../constants/ActionTypes';

/**
 * Reset audit log function
 * @function resetAuditLog
 * @returns {Object} Reset audit log action
 */
export function resetAuditLog() {
  return {
    type: RESET_AUDIT_LOG,
  };
}

/**
 * Get audit log function
 * @function getAuditLog
 * @param {string} path Path to search audit logs
 * @param {number} b_start Batch start position
 * @param {number} b_size Batch size
 * @param {string} portal_type Content type filter
 * @param {string} username Username filter
 * @param {string} action Action filter (create, modify, delete)
 * @param {string} creation_date_start Creation date start filter
 * @param {string} creation_date_end Creation date end filter
 * @param {string} modification_date_start Modification date start filter
 * @param {string} modification_date_end Modification date end filter
 * @param {string} sort_on Sort field (creation_date or modification_date)
 * @param {string} sort_order Sort order (asc or desc)
 * @returns {Object} Get audit log action
 */
export function getAuditLog(
  path = '',
  b_start = 0,
  b_size = 25,
  portal_type = '',
  username = '',
  action = '',
  creation_date_start = '',
  creation_date_end = '',
  modification_date_start = '',
  modification_date_end = '',
  sort_on = '',
  sort_order = '',
) {
  const params = new URLSearchParams({
    b_start: b_start.toString(),
    b_size: b_size.toString(),
  });

  if (path) params.append('path', path);
  if (portal_type) params.append('portal_type', portal_type);
  if (username) params.append('username', username);
  if (action) params.append('action', action);
  if (creation_date_start)
    params.append('creation_date_start', creation_date_start);
  if (creation_date_end) params.append('creation_date_end', creation_date_end);
  if (modification_date_start)
    params.append('modification_date_start', modification_date_start);
  if (modification_date_end)
    params.append('modification_date_end', modification_date_end);

  return {
    type: GET_AUDIT_LOG,
    request: {
      op: 'get',
      path: `/@audit-log?${params.toString()}`,
    },
  };
}

/**
 * Get audit log CSV function
 * @function getAuditLogCsv
 * @param {string} path Path to search audit logs
 * @param {number} b_start Batch start position
 * @param {number} b_size Batch size
 * @param {string} portal_type Content type filter
 * @param {string} username Username filter
 * @param {string} action Action filter (create, modify, delete)
 * @param {string} creation_date_start Creation date start filter
 * @param {string} creation_date_end Creation date end filter
 * @param {string} modification_date_start Modification date start filter
 * @param {string} modification_date_end Modification date end filter
 * @param {string} sort_on Sort field (creation_date or modification_date)
 * @param {string} sort_order Sort order (asc or desc)
 * @returns {Object} Get audit log CSV action
 */
export function getAuditLogCsv(
  path = '',
  b_start = 0,
  b_size = 25,
  portal_type = '',
  username = '',
  action = '',
  creation_date_start = '',
  creation_date_end = '',
  modification_date_start = '',
  modification_date_end = '',
  sort_on = '',
  sort_order = '',
) {
  const params = new URLSearchParams({
    b_start: b_start.toString(),
    b_size: b_size.toString(),
  });

  if (path) params.append('path', path);
  if (portal_type) params.append('portal_type', portal_type);
  if (username) params.append('username', username);
  if (action) params.append('action', action);
  if (creation_date_start)
    params.append('creation_date_start', creation_date_start);
  if (creation_date_end) params.append('creation_date_end', creation_date_end);
  if (modification_date_start)
    params.append('modification_date_start', modification_date_start);
  if (modification_date_end)
    params.append('modification_date_end', modification_date_end);

  return {
    type: GET_AUDIT_LOG_CSV,
    request: {
      op: 'get',
      path: `/@audit-log-csv?${params.toString()}`,
    },
  };
}
